import { createContext } from "react";

export const EventLabelContext = createContext<string | undefined>(undefined);
